import React from 'react';
import { List, Space, Tooltip } from 'antd';
import { StarFilled, DeleteOutlined, InboxOutlined } from '@ant-design/icons';
import styles from './StatusSidebar.module.css';

const FavoritesList = ({ favorites, pipelines, statuses, onStatusSelect, onToggleFavorite }) => {
  const favStatuses = statuses.filter(s => favorites.includes(s.amo_status_id));
  
  if (favStatuses.length === 0) {
    return (
      <div className={styles.emptyState}>
        <InboxOutlined className={styles.emptyIcon} />
        <div className={styles.emptyText}>
          Нет избранных статусов.<br />
          Нажмите на ⭐ чтобы добавить в избранное.
        </div>
      </div>
    );
  }

  return (
    <List
      size="small"
      dataSource={favStatuses}
      renderItem={status => (
        <div className={styles.listItem}>
          <div 
            className={styles.listItemContent}
            onClick={() => onStatusSelect(status)}
          >
            <StarFilled style={{ color: '#fadb14', fontSize: '12px' }} />
            <Tooltip title={`${pipelines[status.pipeline_id]?.name} → ${status.name}`}>
              <div className={styles.listItemText}>
                {pipelines[status.pipeline_id]?.name} → {status.name}
              </div>
            </Tooltip>
          </div>
          <div className={styles.listItemActions}>
            <Tooltip title="Убрать из избранного">
              <button
                className={`${styles.actionButton} ${styles.favoriteButton}`}
                onClick={(e) => {
                  e.stopPropagation();
                  onToggleFavorite(status.amo_status_id);
                }}
              >
                <DeleteOutlined style={{ fontSize: '10px' }} />
              </button>
            </Tooltip>
          </div>
        </div>
      )}
    />
  );
};

export default FavoritesList; 